export const sendToGa4Dictionary = (
  action,
  actionParams,
  label,
  isFrisbuyAnalytic = false
) => {
  const actionPrefix = "frisbuy_";

  const GOOGLE_TAG = isFrisbuyAnalytic
    ? actionParams.settings.analytics.ga4.frisbuyTrackerId || undefined
    : actionParams.settings.analytics.ga4.clientTrackerId || undefined;

  if (!GOOGLE_TAG) {
    return;
  }

  switch (action) {
    // STORIES WIDGET
    case "Load":
      window.frisbuyGa4(
        "event",
        actionPrefix + "sr_load",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
        })
      );
      break;
    case "Eyesight":
      window.frisbuyGa4(
        "event",
        actionPrefix + "sr_eyesight",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
        })
      );
      break;
    case "ClickPic":
      window.frisbuyGa4(
        "event",
        actionPrefix + "sr_clickpost",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
        })
      );
      break;
    case "ViewPic":
      window.frisbuyGa4(
        "event",
        actionPrefix + "sr_viewpost",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
        })
      );
      break;
    case "ClickLink":
      window.frisbuyGa4(
        "event",
        actionPrefix + "sr_clicklink",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
          link_id: label.link,
          link_label: label.linklabel,
          link_url: label.linkUrl,
        })
      );
      break;
    case "Swipe":
      window.frisbuyGa4(
        "event",
        actionPrefix + "swipe",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
        })
      );
      break;

    // UPLOAD WIDGET
    case "UplphotoOpen":
      window.frisbuyGa4(
        "event",
        actionPrefix + "uplphoto_open",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
        })
      );
      break;
    case "UplphotoSelected":
      window.frisbuyGa4(
        "event",
        actionPrefix + "uplphoto_selected",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          link_id: label.link,
          link_label: label.linklabel,
        })
      );
      break;
    case "UplphotoError":
      window.frisbuyGa4(
        "event",
        actionPrefix + "uplphoto_error",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          link_id: label.link,
          link_label: label.linklabel,
        })
      );
      break;
    case "UplphotoUploaded":
      window.frisbuyGa4(
        "event",
        actionPrefix + "uplphoto_uploaded",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          link_id: label.link,
          link_label: label.linklabel,
        })
      );
      break;
    case "UplphotoOK":
      window.frisbuyGa4(
        "event",
        actionPrefix + "uplphoto_ok",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          link_id: label.link,
          link_label: label.linklabel,
        })
      );
      break;

    // DUMMY
    case "frisbuy_showstubview":
      window.frisbuyGa4(
        "event",
        actionPrefix + "showstubview",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          gallery_id: actionParams.settings.galleryId,
          embed_id: actionParams.settings.embedId,
          sku_id: actionParams.settings.skuId,
        })
      );
      break;

    default:
      console.log("switch DEFAULT - NOT match any case!");
      break;
  }
};

const deleteEmptyFields = (object) => {
  for (const field in object) {
    if (
      !object[field] &&
      typeof object[field] !== "number" &&
      typeof object[field] !== "boolean"
    ) {
      delete object[field];
    }
  }

  return object;
};

const getStock = (embedId, skuId) => {
  if (!embedId || !skuId) {
    return null;
  }

  const media = [];
  const linkList = [];

  let isAvailable = null;

  window.frisbuy[embedId].postList.forEach((post) => {
    if (post && post.media && post.media.length > 0) {
      media.push(...post.media);
    }
  });

  media.forEach((media) => {
    linkList.push(...media.linkList);
  });

  for (let i = 0; i < linkList.length; i++) {
    if (linkList[i].sku.offerId === skuId) {
      isAvailable = linkList[i].sku.isAvailable;

      break;
    }
  }

  return isAvailable;
};
